import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { routerShape } from 'react-router/lib/PropTypes';
import Helmet from 'react-helmet';
import Formsy from 'formsy-react';
import { autobind } from 'core-decorators';

import { passwordValidation } from 'utils/validationRules';

import { changePassword } from 'services/api';
import { login } from 'actions';

import PageHeader from 'AppComponents/PageHeader';
import Alert from 'AppComponents/Alert';
import Input from 'AppComponents/Forms/Input';
import SubmitButton from 'AppComponents/SubmitButton';


class PasswordReset extends Component {

  static propTypes = {
    dataFromServer: PropTypes.shape({
      validlink: PropTypes.bool,
      title: PropTypes.string,
    }).isRequired,
    isLoggedIn: PropTypes.bool,
    loginRequest: PropTypes.func.isRequired,
    params: PropTypes.shape({
      uidb64: PropTypes.string,
      token: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    isLoggedIn: false,
  };

  static contextTypes = {
    router: routerShape.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      enableSubmit: false,
      isSubmitting: false,
      serverError: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoggedIn) this.context.router.push('/user/account/');
  }

  @autobind
  handleSubmit(data, resetForm, invalidateForm) {
    this.setState({ isSubmitting: true }, () => {
      changePassword(data).then(({ response, error }) => {
        if (error) {
          this.setState({ isSubmitting: false });
          if (typeof error === 'object') {
            this.setState({ serverError: error.detail });
            delete error.detail;
            if (error.uidb64 || error.token) {
              this.setState({ serverError: 'There seems to be a problem with your password reset token. Please check the URL and try again.' }); // eslint-disable-line max-len
            }
            const errors = {};
            Object.keys(error).forEach((field) => {
              errors[field] = error[field][0];
            });
            invalidateForm(errors);
          } else {
            this.setState({ serverError: 'An unknown error occurred. Please try again.' });
          }
        } else {
          this.props.loginRequest(response.username, data.password);
        }
      });
    });
  }

  @autobind
  mapInputs(inputs) {
    const { params } = this.props;
    const newInputs = Object.assign({}, inputs, {
      uidb64: params.userId,
      token: params.token,
    });
    delete newInputs.password2;
    return newInputs;
  }

  render() {
    const { validlink, title } = this.props.dataFromServer;
    return (
      <div className='container'>

        <Helmet title={title} />

        <PageHeader title={title} />

        <Alert type='danger' display={this.state.serverError && true}>
          <strong>Error: </strong>{ this.state.serverError }
        </Alert>

        { validlink ?

          <Formsy.Form
            className='form-horizontal with-feedback'
            onValid={() => this.setState({ enableSubmit: true })}
            onInvalid={() => this.setState({ enableSubmit: false })}
            onValidSubmit={this.handleSubmit}
            mapping={this.mapInputs}
            noValidate
          >

            <p className='help-block'>
              Please enter your new password twice so we can verify you typed it in correctly.
            </p>

            <Input
              type='password'
              name='password'
              label='Password'
              {...passwordValidation}
              required
            />

            <Input
              type='password'
              name='password2'
              label='Password Confirmation'
              validations='equalsField:password'
              validationError='Passwords must match.'
              required
            />

            <div className='form-footer'>
              <div className='aligned-with-input'>
                <SubmitButton
                  label='Reset Password'
                  className='pull-right'
                  enabled={this.state.enableSubmit}
                  isSubmitting={this.state.isSubmitting}
                />
              </div>
            </div>

          </Formsy.Form>

        :

          <Alert type='danger'>
            The password reset link was invalid, possibly because it has already been used.&nbsp;
            Please request a new password reset.
          </Alert>

        }

      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isLoggedIn,
  loggingIn: state.auth.loggingIn,
  loginError: state.auth.loginError,
  dataFromServer: state.auth.passwordReset,
});

const loginRequest = login.request;

export default connect(
  mapStateToProps, {
    loginRequest,
  },
)(PasswordReset);



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/PasswordReset/index.jsx